import type { WidgetTypeSelectorProps } from "./types";

export function WidgetTypeSelector({ selectedType, options, enabledTypes, onChange, blockedMessage }: WidgetTypeSelectorProps) {
    const isBlocked = !!blockedMessage;

    return (
        <div className="relative">
            <div className={`grid grid-cols-2 gap-3 ${isBlocked ? "pointer-events-none" : ""}`}>
                {options.map((option) => {
                    const isEnabled = enabledTypes[option.value];
                    const isSelected = selectedType === option.value;
                    const Icon = option.icon;

                    return (
                        <button
                            key={option.value}
                            type="button"
                            onClick={() => onChange(option.value)}
                            disabled={!isEnabled || isBlocked}
                            className={`flex flex-col items-start gap-2 rounded-lg border-2 p-3 transition ${
                                isBlocked
                                    ? "border-[#f0f0f0] bg-[#f9f9f9] text-[#999999] opacity-50"
                                    : isSelected
                                      ? "border-[#079a95] bg-[#e8f5f4]"
                                      : isEnabled
                                        ? "border-[#e0e0e0] bg-white hover:border-[#079a95]"
                                        : "border-[#f0f0f0] bg-[#f9f9f9] text-[#999999]"
                            }`}
                        >
                            <Icon className="h-5 w-5" />
                            <div className="text-left">
                                <div className="text-sm font-medium font-roboto">{option.label}</div>
                                <div className="text-xs text-[#666666] font-roboto">{option.description}</div>
                            </div>
                        </button>
                    );
                })}
            </div>
            {isBlocked && (
                <div className="absolute inset-0 flex items-center justify-center rounded-lg bg-white/50">
                    <p className="text-center text-sm font-medium text-[#2d3a3f] px-4 font-roboto">{blockedMessage}</p>
                </div>
            )}
        </div>
    );
}
